import { FormValues } from '@stern-ui/ui';
import { formatPhoneNumberValue } from '@stern-ui/utilities';

import { CancelledStatus, isUs, phoneNumberPrefix, Status } from '@/globalConsts';

import { EditPatientRequestResponse } from '../types';

export * from './componentUtils';

export const CheckScreeningRequiredStatus = (
	status: Status,
	status_label: string,
	cancelled: CancelledStatus,
	cancelled_label: string
) => {
	switch (status) {
		case Status.Consented:
			if (cancelled === CancelledStatus.NotCancelled) {
				return 'Screening Required';
			}
			break;
		case Status.ReScreening:
			if (cancelled === CancelledStatus.NotCancelled) {
				return 'Re-Screening Required';
			}
			break;
		case Status.Screened:
			if (cancelled === CancelledStatus.NotCancelled) {
				return 'Screening Passed';
			}
			break;
		case Status.ConsentDelegated:
			return 'Consent Delegated';
	}

	switch (cancelled) {
		case CancelledStatus.ScreeningNotEligible:
			return 'Screening Failed';
		case CancelledStatus.NotCancelled:
			break;
		default:
			return cancelled_label;
	}
	return status_label;
};

export const formatPhoneNumberDisplay = (phoneNumber: string | undefined) => {
	// Format phone numbers for display, remove any country code prefixs,
	//add a leading 0 if a UK number or format as (XXX) XXX-XXXX if a US number
	if (phoneNumber && phoneNumber.length >= 1) {
		const trimmedPhoneNumber = phoneNumber.slice(phoneNumberPrefix.length);
		if (isUs) {
			return `(${trimmedPhoneNumber.slice(0, 3)}) ${trimmedPhoneNumber.slice(
				3,
				6
			)}-${trimmedPhoneNumber.slice(6, 10)}`;
		} else {
			return '0' + trimmedPhoneNumber;
		}
	}
	return '';
};

export const formatPatientDetailValues = (valuesObj: FormValues) => {
	const mobileNumber = formatPhoneNumberValue(
		valuesObj.contact_mobile_number as string,
		phoneNumberPrefix
	);
	const homeNumber = formatPhoneNumberValue(
		valuesObj.contact_home_number as string,
		phoneNumberPrefix
	);

	const returnObj: EditPatientRequestResponse = {
		contact_email: valuesObj.contact_email as string,
		contact_mobile_number: mobileNumber,
		contact_home_number: homeNumber,
		needs_assistance: valuesObj.needs_assistance === 'true',
		opt_out_reason: valuesObj.opt_out_reason as string,
		opt_out_reason_other: valuesObj.opt_out_reason_other as string,
	};

	// Only include opt_out if value is exactly 'true'
	if (valuesObj.opt_out === 'true') {
		returnObj['opt_out'] = true;
	}

	// Only include deceased if value is exactly 'true'
	if (valuesObj.deceased === 'true') {
		returnObj['deceased'] = true;
	}

	return returnObj;
};

export const capitaliseFirstLetter = (str: string | undefined) => {
	return str && str.charAt(0).toUpperCase() + str.slice(1);
};
